<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Blog Left Sidebar" />
            <BlogLeftSidebar />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import BlogLeftSidebar from '../BlogLeftSidebar/BlogLeftSidebar'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'BlogLeftSidebarPage',
    components: {
        NavBar,
        PageTitle,
        BlogLeftSidebar,
        FooterComp,
    }
}
</script>